module.exports = __webpack_public_path__ + "img/forecast_groups.787b9bfd.png";